import {makeAutoObservable} from "mobx";
import type {BagStore} from "../BagStore";
import type ProfileStore from "../ProfileStore";
import type {MithraMaterializedApi} from "../../services/MithraMaterializedApi";
import type {SynergyStore} from "../SynergyStore";

/**
 * The synergy store for common suppliers
 */
export class CommonSuppliersDelegate {
    readonly numberTotalSuppliersLeft: number;
    readonly numberTotalSuppliersRight: number;
    readonly numberTotalCommonSuppliers: number;
    readonly numberCommonSuppliersLeft: number;
    readonly numberCommonSuppliersRight: number;
    readonly totalSpendCommonSuppliers: number;
    readonly totalSuppliersSpendLeft: number;
    readonly totalSuppliersSpendRight: number;
    readonly commonSuppliersSpendLeft: number;
    readonly commonSuppliersSpendRight: number;

    // noinspection JSUnusedLocalSymbols
    constructor(
        private synergyStore: SynergyStore,
        private bagStore: BagStore,
        private api: MithraMaterializedApi,
        private profileStore: ProfileStore,
    ) {
        makeAutoObservable(this);

        this.numberTotalSuppliersLeft = this.profileStore.p.hardcodedNumberTotalSuppliersLeft || -1;
        this.numberTotalSuppliersRight = this.profileStore.p.hardcodedNumberTotalSuppliersRight || -1;
        this.numberTotalCommonSuppliers = this.profileStore.p.hardcodedNumberTotalCommonSuppliers || -1;
        this.numberCommonSuppliersLeft = this.profileStore.p.hardcodedNumberCommonSuppliersLeft || -1;
        this.numberCommonSuppliersRight = this.profileStore.p.hardcodedNumberCommonSuppliersRight || -1;
        this.totalSpendCommonSuppliers = this.profileStore.p.hardcodedTotalSpendCommonSuppliers || -1;
        this.totalSuppliersSpendLeft = this.profileStore.p.hardcodedTotalSuppliersSpendLeft || -1;
        this.totalSuppliersSpendRight = this.profileStore.p.hardcodedTotalSuppliersSpendRight || -1;
        this.commonSuppliersSpendLeft = this.profileStore.p.hardcodedCommonSuppliersSpendLeft || -1;
        this.commonSuppliersSpendRight = this.profileStore.p.hardcodedCommonSuppliersSpendRight || -1;
    }

    init() {
        const synergy = this.synergyStore.requestedSynergyId;
        console.log('CommonSuppliersDelegate.init', synergy);
    }
}
